module.exports = __webpack_public_path__ + "img/board.07044913.png";